import { jsx as _jsx } from "react/jsx-runtime";
import { sanitizeHTML, transformRichText } from '../../utils';
export const RichTextField = ({ value, wrapperTag = 'span', ...rest }) => {
    const sanitizedValue = transformRichText(sanitizeHTML(value));
    const Tag = wrapperTag;
    return _jsx(Tag, { ...rest, dangerouslySetInnerHTML: { __html: sanitizedValue } });
};
